import React from "react";
import AutomationList from "../shared/components/AutomationList";
import { WORKFLOW_CATEGORY } from "../workflow/utils/enums";

const TicketsAutomation: React.FC = () => {
  return (
    <AutomationList
      workflowCategory={WORKFLOW_CATEGORY.TICKET}
      title="Tickets Automation"
      breadcrumb="Tickets"
      module="tickets"
    />
  );
};

export default TicketsAutomation;
